<template>
    <div class="frontend">
        <v-navbar/>
        <slot/>
        <v-country/>
        <v-footer/>
    </div>
</template>

<script>
import vFooter from './footer'
import vNavbar from './navbar'
export default {
    components: {
        vFooter,
        vNavbar
    }
}
</script>

<style lang="scss">
.frontend {
    position: relative;
    min-height: 100vh;
    padding-top: 60px;
    display: flex;
    flex-direction: column;

    main {
        flex-grow: 1;
    }
}
</style>
